// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Xzj1","footer":"ModalCreateQualiphyProcedure_footer__3LPpU","additionData":"ModalCreateQualiphyProcedure_additionData__1JC3H"};